export default __webpack_public_path__ + "4ffcbc1b830b58026bd654398a5d0350.png";